<div class="cx-clear-cart-container">
  <ng-container>
    <output [attr.aria-label]="'common.loaded' | cxTranslate"></output>
    <!-- Modal Header -->
    <div class="modal-header cx-clear-cart-header">
      <div class="cx-clear-cart-title modal-title">
        Ingrese rango de fechas:
      </div>

      <button
        [attr.aria-label]="'common.close' | cxTranslate"
        class="close"
        type="button"
      ></button>
    </div>

    <!-- Modal Body -->
    <div class="cx-clear-cart-body">
      <div class="clear-cart-msg">
        FECHA DESDE:
      </div>
      <cx-date-picker
        [control]="$any(form.get('startDate'))"
        [max]="form.get('endDate')?.value"
        [required]="true"
        (update)="form.get('endDate')?.updateValueAndValidity()"
      >
      </cx-date-picker>

      <div class="clear-cart-msg">
        FECHA HASTA:
      </div>

      <cx-date-picker
        [control]="$any(form.get('endDate'))"
        [min]="form.get('startDate')?.value"
        [max]="maxDate | date: 'yyyy-MM-dd'"
        [required]="true"
        (update)="form.get('startDate')?.updateValueAndValidity()"
      >
      </cx-date-picker>

      <div>
        <div class="cx-clear-cart-footer">
          <button class="btn btn-secondary" type="button" (click)="close('closing modal cart' )">
            {{ 'common.cancel' | cxTranslate }}
          </button>
          <button  class="btn btn-primary" type="button" (click)="download()">
            DESCARGAR
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
